import banner from "../../assets/img/service-banner2.avif";

const SupplyChain = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>Supply Chain Management</h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={banner}
                alt="Supply Chain Management"
                className="img-fluid"
                title="Supply Chain Management"
              />
              <p>
                At GGAS, we recognize that a high-performing supply chain is
                essential to achieving both operational excellence and strategic
                growth. In today’s dynamic market environment, supply chains are
                under increasing pressure to deliver agility, cost efficiency,
                resilience, and service reliability—all while supporting complex
                global operations.
              </p>
              <p>
                Our supply chain consulting services are designed to transform
                your supply chain into a true strategic asset. We partner with
                clients to assess, design, and optimize end-to-end supply chain
                processes, aligning them with business objectives to drive
                measurable improvements in performance and competitiveness.
              </p>
              <p>
                From network design and inventory optimization to supplier
                management, logistics strategy, and risk mitigation, GGAS
                delivers data-driven solutions that unlock value, reduce total
                cost-to-serve, and enhance responsiveness across
                the value chain.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SupplyChain;
